module.exports = __webpack_public_path__ + "static/media/favoritos.a7d1345f.png";